import React from 'react';
import { Controller } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { AppTextInput } from 'components/FormElements';
import { getCurrencySymbol } from 'further-ui/utils';

const NarrowAppTextInput = (props) => <AppTextInput {...props} narrow />;

export type NumericInputCellProps = {
  control: any;
  name: string;
  onChange?: (value: number) => void;
  currency?: CurrencyCode;
  disabled?: boolean;
  showPercentage?: boolean;
  allowNegative?: boolean;
  fixedDecimalScale?: boolean;
  decimalScale?: number;
};

const NumericInputCell: React.FC<NumericInputCellProps> = ({
  control,
  name,
  onChange = () => {},
  currency,
  disabled = false,
  showPercentage = false,
  allowNegative = false,
  fixedDecimalScale = false,
  decimalScale,
}) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange: fieldOnChange } }) => (
        <NumericFormat
          value={value}
          onChange={(e) => {
            const newValue = e.target.value.replace(/[^\d.-]/g, '');
            const newNumberValue = Number(newValue);

            const isNaN = Number.isNaN(newNumberValue);
            if (isNaN) {
              return;
            }

            fieldOnChange(newNumberValue);
            onChange(newNumberValue);
          }}
          allowNegative={allowNegative}
          decimalScale={decimalScale ?? 2}
          fixedDecimalScale={fixedDecimalScale}
          allowLeadingZeros={false}
          thousandSeparator={true}
          prefix={
            currency
              ? getCurrencySymbol(currency, { withSpace: true })
              : undefined
          }
          suffix={showPercentage ? '%' : undefined}
          customInput={NarrowAppTextInput}
          disabled={disabled}
        />
      )}
    />
  );
};

export default NumericInputCell;
